import getCategoryError from "./getCategoryError";

const getCategoryStatusIsNotFound = state =>
  getCategoryError(state)?.status === 404;

export default getCategoryStatusIsNotFound;
